import useEntries from '../Common/useEntries';

/** How long a publication counts as "New" after it is uploaded to the CMS. */
export const NEW_FOR_DAYS = 14;

/** When the document was uploaded (CMS creation time), as milliseconds; null if unknown. */
export function uploadedAt(entry) {
    const time = new Date(entry?.sys?.createdAt || entry?.fields?.createdAt || '').getTime();
    return Number.isNaN(time) ? null : time;
}

export function isNewPublication(entry, now = Date.now()) {
    const time = uploadedAt(entry);
    return time !== null && time <= now + 60000 && now - time < NEW_FOR_DAYS * 86400000;
}

/** Newest upload first; entries without a known upload time go last. */
export function byLatestUpload(a, b) {
    return (uploadedAt(b) ?? -Infinity) - (uploadedAt(a) ?? -Infinity);
}

/** True while the most recently uploaded publication is still within the "New" period. */
export function useHasNewPublication() {
    const { items } = useEntries({ content_type: 'publications', order: '-sys.createdAt', limit: 1 });
    return items.length > 0 && isNewPublication(items[0]);
}
